export default __webpack_public_path__ + "static/media/demo4.c6d1fffb.png";